import { takeLatest } from 'redux-saga/effects';
import { onList, onListSuccess, onListFailed } from './List';
import { OrgUnitTypes } from '~/domain/interfaces/redux/orgUnit/types';

const tasks = [
  takeLatest(OrgUnitTypes.LIST, onList),
  takeLatest(OrgUnitTypes.LIST_SUCCESS, onListSuccess),
  takeLatest(OrgUnitTypes.LIST_FAILED, onListFailed),
];

export default tasks;
